import React, { useMemo, useState } from 'react';
import { Space } from 'antd';
import { I18n } from 'react-redux-i18n';
import get from 'lodash/get';

import Notebook from 'components/Notebook';
import TitleComponent from 'modules/Dashboard/components/TitleComponent';
import Container, {
  ButtonContainer
} from 'modules/Dashboard/components/LastMarketNotebook/container';

const LastMarketNotebookComponent = ({ data }) => {
  const [displayedIndex, setDisplayedIndex] = useState(0);

  const onClick = () => {
    if (displayedIndex === get(data, 'length') - 1) {
      setDisplayedIndex(0);
    } else {
      setDisplayedIndex(displayedIndex + 1);
    }
  };

  const marketNoteBook = useMemo(() => {
    return data[displayedIndex];
  }, [displayedIndex, data]);

  const nbRestaurants = useMemo(() => {
    return get(marketNoteBook, 'nbRestaurants', 0);
  }, [marketNoteBook]);

  // @TODO add subscribe action
  return (
    <Container>
      <Space size={20} className="titleContainer">
        <ButtonContainer onClick={onClick} />
        <TitleComponent>
          {I18n.t('dashboard.lastMarketOnlineTitle').toUpperCase()}
        </TitleComponent>
      </Space>
      {data && get(data, 'length') > 0 && (
        <Notebook
          name={get(marketNoteBook, 'city')}
          networkCode={get(marketNoteBook, 'networkCode')}
          releaseDate={get(marketNoteBook, 'date')}
          dnClient={nbRestaurants}
          imagePath={get(marketNoteBook, 'marketImagePath')}
          presentationPath={get(marketNoteBook, 'marketPresentationPath')}
          subscribed={marketNoteBook.subscribed}
          continuousMode={false}
          fullContent={false}
        />
      )}
    </Container>
  );
};

export default LastMarketNotebookComponent;
